<template>
  <div class="coupon-wrapper">
    <div>
      <img :src="imgUrl" alt="" width="100%">
    </div>
    <div v-if="checkFlag == 0" @click="goNameAuthen" class="essc-top"></div>
    <div v-if="checkFlag == 1 || checkFlag == 2" @click="goMyEssc" class="essc-top"></div>
    <div v-if="checkFlag == 2" @click="esscReceive" class="essc-receive"></div>
    <div v-if="showFlag == 0" @click="goMyEssc" class="essc-my"></div>
  </div>
</template>

<script>
import { esscCheck, esscReceive } from '@/api/active'
import { setStore } from '@/utils/index'
import { Dialog } from 'vant'
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      showFlag: null,
      checkFlag: -1,
      data: null,
      imgUrl: '',
      imgSocialIsApply: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/social/bg_social_n.png',
      imgSocialUnApply: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/social/bg_social_u.png',
      imgMySocial: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/social/bg_my_social.png'
    }
  },
  mounted () {
    const token = this.$route.query.accessToken
    if (token) {
      setStore('token', token)
      this.handlEsscCheck()
    } else {
      this.goLogin()
    }
  },
  methods: {
    goLogin () {
      /* eslint-disable */
      dsBridge.call('callLogin',function(res) {
        const token = res
        if (res) {
          setStore('token', token)
        }
      })
    },
    handlEsscCheck () {
      esscCheck().then((res) => {
        const data = res.data.result
        if (data) {
          this.showFlag = data.showFlag
          if(data.showFlag == 0){
            // 是否可参与活动 0显示我的电子社保卡
            this.imgUrl = this.imgMySocial
          }else {
            // 2-已开通电子社保卡 1-未开通电子社保卡（已实名） 0-未实名
            this.checkFlag = data.checkFlag
            if(data.checkFlag == 2){
              this.imgUrl = this.imgSocialIsApply
            }else {
              this.imgUrl = this.imgSocialUnApply
            }
          }
          this.data = data
        } else {
          console.log('其他')
        }
      })
    },
    goMyEssc () {
      if(this.checkFlag == 1){
        if (window._czc) {
          window._czc.push(['_trackEvent', '去申领电子社保卡按钮', '去申领电子社保卡按钮', '去申领电子社保卡按钮', '', '2036btn02'])
        }
      }
      const data = this.data
      if (data) {
        // 跳转到原生界面
        /* eslint-disable */
        dsBridge.call('callNativeViewLifeCycle', {
          androidGoPage: data.androidGoPage,
          iosGoPage: data.iosGoPage,
          appId: data.appId,
          appType: data.appType,
          appStartUrl: data.appStartUrl,
          authorize: 0,
          addToolbar: data.addToolbar
        })
      }
    },
    esscReceive () {
      esscReceive().then((res) => {
        const data = res.data.result
        if (data) {
          if (window._czc) {
            window._czc.push(['_trackEvent', '去抽奖按钮', '去抽奖按钮', '去抽奖按钮', '', '2036btn03'])
          }
          window.location.href = data
        } else {
          console.log('其他')
        }
      })
    },
    goNameAuthen () {
      Dialog.confirm({
        title: '温馨提示',
        message: '根据相关规定，申领电子社保卡需要先完成个人实名认证',
        cancelButtonText: '取消',
        confirmButtonText: '去实名',
        confirmButtonColor: '#4F7DFF'
      }).then(() => {
        /* eslint-disable */
        dsBridge.call('callNameAndFaceAuthen', function (token) {
          console.log('原生认证成功')
          this.handlEsscCheck()
        })
      }).catch(() => {

      })

    }
  }
}

</script>
<style lang='scss' scoped>

.coupon-wrapper {
  position: relative;
  min-height: 100vh;
  img {
    display: block;
    width: 100%;
  }
  .essc-top {
    position: absolute;
    top: 50%;
    width: 100%;
    height: 20%;
  }
  .essc-receive {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 15%;
  }
  .essc-my {
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 15%;
  }
}

</style>
